const isClientHttpError = (error: unknown): boolean =>
  isNuxtError(error) && !!error.statusCode && error.statusCode >= 300 && error.statusCode < 500

export default defineNuxtPlugin((nuxtApp) => {
  const { sentryDsn, environment } = useRuntimeConfig().public

  if (!sentryDsn) {
    return
  }

  const pendingErrors: unknown[] = []
  let capture = (error: unknown): void => {
    pendingErrors.push(error)
  }

  nuxtApp.hook('vue:error', error => capture(error))
  nuxtApp.hook('app:error', (error) => {
    if (!isClientHttpError(error)) {
      capture(error)
    }
  })

  onNuxtReady(async () => {
    const { init, captureException } = await import('@sentry/nuxt')

    init({
      dsn: sentryDsn,
      environment,
      debug: false,
      enableLogs: false,
      sendDefaultPii: false,
      sampleRate: 0.4,
      tracesSampleRate: 0,
    })

    capture = error => captureException(error)
    pendingErrors.forEach(capture)
  })
})
